import React from "react";
import { Heading, Text } from "@foris/avocado-suite";
import styles from "./classroomParamsItem.module.scss";

interface Props {
  title: string;
  value: string | number;
}

const ClassroomParamsItem = ({ title, value }: Props) => {
  return (
    <div className={styles.classroomParamsItem}>
      <Heading type="h4" className={styles.classroomParamsItem_title}>
        {title}
      </Heading>
      <Text className={styles.classroomParamsItem_value}>{value}</Text>
    </div>
  );
};

export default ClassroomParamsItem;
